module.exports = __webpack_public_path__ + "media/images/ponce_battery_horizontal-2c38f521.png";